import React from 'react';
import {
  Hits,
  Index,
  useStats,
  Configure,
} from 'react-instantsearch-hooks-web';
import { classnames } from 'helpers/utils';
import { IndexTypeEnum } from 'utils/enums';
import PageHit from './page-hit';
import * as styles from './search-styles.module.scss';

interface HitsInIndexProps {
  index: {
    name: string;
  }
}

interface SearchResultProps {
  indices: {
    name: string;
  }[];
  show: boolean;
  className?: string;
}

interface HitCountProps {
  indexName: string;
}

const HitCount = ({ indexName }: HitCountProps) => {
  const { nbHits } = useStats();
  return nbHits > 0 ? (
    <div>
      <div className={styles.hitCount}>
        {`${nbHits} result`}
        {nbHits !== 1 ? 's' : ''}
      </div>
      <span className={styles.indexTitle}>{indexName}</span>
    </div>
  ) : <p className={styles.indexTitle}>{`No results for ${indexName}`}</p>;
};

const getIndexLimit = (indexName: string): number => {
  switch (indexName) {
    case IndexTypeEnum.articles: return 4;
    case IndexTypeEnum.tags: return 5;
    case IndexTypeEnum.authors: return 2;
    default:
      return 3;
  }
};

const HitsInIndex = ({ index }: HitsInIndexProps) => {
  const capitalizedIndexName = index.name.charAt(0).toUpperCase() + index.name.slice(1);
  const hitLimit = getIndexLimit(index.name);
  return (
    <Index indexName={index.name}>
      <Configure hitsPerPage={hitLimit} />
      <HitCount indexName={capitalizedIndexName} />
      <Hits className={styles.hits} hitComponent={PageHit} />
    </Index>
  );
};

const SearchResult = ({ indices, show, className }: SearchResultProps) => (
  <div className={classnames(styles.searchResult, className || '', show ? styles.show : '')}>
    {indices.map((index: { name: string }) => (
      <HitsInIndex index={index} key={index.name} />
    ))}
  </div>
);

export default SearchResult;
